// extracted by mini-css-extract-plugin
module.exports = {"btnDangerWrapper":"PricingGroups_btnDangerWrapper__2dD0s"};